import { useMemo } from 'react'
import {
  EntitySearchCellDef,
  TextCellDef,
  TicketListAutocompleteProps,
  TicketListCellDef,
} from '../../../../../../containers/SingleSheetV2/table/model'
import { intl } from '../../../../../../../i18n'

export type TicketListCellProps = TicketListAutocompleteProps

export const useTicketList = ({
  options,
  onFocus,
  groupBy,
  renderOption,
  renderGroupLabel,
  renderInput,
  defaultExpandedGroups,
  popperWidth,
  listFooter,
}: TicketListCellProps): TicketListCellDef => {
  const cellDef = useMemo<TicketListCellDef>(() => {
    return {
      externalId: 'ticketList',
      field: 'ticketList',
      label: intl.formatMessage({ id: 'ticketList' }),
      type: 'TICKET_LIST',
      width: 'half',
      required: true,
      editable: true,
      options,
      onFocus,
      renderOption,
      renderInput,
      groupBy,
      renderGroupLabel,
      defaultExpandedGroups,
      popperWidth,
      listFooter,
    }
  }, [
    options,
    onFocus,
    renderOption,
    renderGroupLabel,
    renderInput,
    groupBy,
    defaultExpandedGroups,
    popperWidth,
    listFooter,
  ])
  return cellDef
}
export const useParentWbsItem = (): EntitySearchCellDef => {
  const cellDef = useMemo<EntitySearchCellDef>(() => {
    return {
      externalId: 'parentWbsItem',
      field: 'parentWbsItem',
      label: intl.formatMessage({ id: 'parentWbsItem' }),
      type: 'ENTITY_SEARCH',
      width: 'full',
      required: false,
      editable: false,
      search: async (searchText: string) => {
        return []
      },
      displayIcon: false,
    }
  }, [])
  return cellDef
}

/**
 * @deprecated
 * This property is not shown.
 * Remove this property after replacing SingleSheetV2 completely.
 * To make the form layout(row index) same as old SingleSheet(function_properties).
 * In function_properties "hidden" of this property is true.
 */
export const useTicketType = (): TextCellDef => {
  const cellDef = useMemo<TextCellDef>(() => {
    return {
      externalId: 'ticketType',
      field: 'ticketType',
      label: intl.formatMessage({ id: 'wbsItem.ticketType' }),
      type: 'TEXT',
      width: 'half',
      required: false,
      editable: false,
      hidden: true,
    }
  }, [])
  return cellDef
}
